{
  "familyId": "TGL-GELD-KOMMA",
  "questions": [
    {
      "id": "TGL-GELD-KOMMA-001",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een boek kost €12,50. Je betaalt met €20. Hoeveel wisselgeld krijg je terug?",
      "options": ["€7,50", "€8,50", "€7,00", "€2,50"],
      "correctAnswer": 0,
      "conceptId": "change_calculation",
      "variantIndex": 1,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wisselgeld met kommagetallen",
            "content": "Wisselgeld = betaald − prijs = €20,00 − €12,50 = €7,50. Let op de komma: reken eerst de centen, dan de euros."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Splits het aftrekken in euro's en centen. Stap 1: €20,00 − €12,00 = €8,00. Stap 2: €8,00 − €0,50 = €7,50. Stap 3: wisselgeld = €7,50.",
        "distractorExplanations": {
          "0": "Correct! €20,00 − €12,50 = €7,50.",
          "1": "Veelgemaakte fout: verkeerd aftrekken van de euro's. €8,50 zou kloppen als het boek €11,50 kostte. Maar €20,00 − €12,50 = €7,50. Controleer: €12,50 + €7,50 = €20,00 ✓.",
          "2": "Veelgemaakte fout: de centen vergeten bij het aftrekken. €7,00 = €20 − €13, maar de prijs is €12,50. Na €20 − €12 = €8 moet je nog €0,50 aftrekken: €8,00 − €0,50 = €7,50.",
          "3": "Veelgemaakte fout: de verkeerde bewerking gebruiken. €2,50 is veel te weinig. Controleer: €20,00 − €12,50 = €7,50 (niet €2,50)."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-002",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Je koopt 3 schriften van €2,75 per stuk. Hoeveel betaal je in totaal?",
      "options": ["€8,25", "€8,75", "€5,75", "€9,25"],
      "correctAnswer": 0,
      "conceptId": "money_multiplication",
      "variantIndex": 2,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met kommagetallen",
            "content": "3 × €2,75 = €8,25. Reken: 3 × €2,00 = €6,00, dan 3 × €0,75 = €2,25. Totaal: €6,00 + €2,25 = €8,25."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de vermenigvuldiging in euro's en centen apart. Stap 1: 3 × €2,00 = €6,00. Stap 2: 3 × €0,75 = €2,25. Stap 3: tel op: €6,00 + €2,25 = €8,25.",
        "distractorExplanations": {
          "0": "Correct! 3 × €2,75 = €8,25.",
          "1": "Veelgemaakte fout: de centen verkeerd vermenigvuldigen. 3 × 75 cent = 225 cent = €2,25 (niet €2,75). Totaal: €6,00 + €2,25 = €8,25, niet €8,75.",
          "2": "Veelgemaakte fout: te weinig schriften rekenen. €5,75 ≈ 2 × €2,75 + iets. Je moet 3 schriften rekenen: 3 × €2,75 = €8,25.",
          "3": "Veelgemaakte fout: afronden vóór het vermenigvuldigen. 3 × €3,00 = €9,00, maar de prijs is €2,75 (niet €3,00). Reken exact: 3 × €2,75 = €8,25."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-003",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een pen kost €1,35. Een schrift kost €2,80. Hoeveel kosten ze samen?",
      "options": ["€4,15", "€4,25", "€3,15", "€4,05"],
      "correctAnswer": 0,
      "conceptId": "money_addition_carry",
      "variantIndex": 3,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met kommagetallen",
            "content": "€1,35 + €2,80 = €4,15. Tel de centen op: 35 + 80 = 115 cent = €1,15. Tel de euros op: €1 + €2 + €1 = €4. Totaal: €4,15."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: tel de centen apart op en let op of je boven de 100 cent komt (dan wordt het een extra euro). Stap 1: centen: 35 + 80 = 115 cent = €1,15. Stap 2: euro's: €1 + €2 = €3. Stap 3: totaal: €3 + €1,15 = €4,15.",
        "distractorExplanations": {
          "0": "Correct! €1,35 + €2,80 = €4,15.",
          "1": "Veelgemaakte fout: de centen verkeerd optellen. 35 + 80 = 115 cent = €1,15 (niet €1,25). Let op: 5 + 0 = 5 (niet 25). Totaal: €4,15.",
          "2": "Veelgemaakte fout: vergeten dat 115 cent een extra euro oplevert. 35 + 80 = 115 cent = €1,15. Die extra €1 moet je bij de euro's optellen: €1 + €2 + €1 = €4. Totaal: €4,15.",
          "3": "Veelgemaakte fout: de centen verkeerd optellen. 35 + 80 = 115 cent = €1,15 (niet €1,05). Let op: 30 + 80 = 110, dan + 5 = 115 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-004",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Je hebt €15,00. Je koopt iets van €8,65. Hoeveel houd je over?",
      "options": ["€6,35", "€6,45", "€7,35", "€5,35"],
      "correctAnswer": 0,
      "conceptId": "money_subtraction_borrow",
      "variantIndex": 4,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken met lenen",
            "content": "€15,00 − €8,65 = €6,35. Reken: €15,00 − €8,00 = €7,00, dan €7,00 − €0,65 = €6,35."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits het aftrekken in euro's en centen. Let op: als je niet genoeg centen hebt, 'leen' je een euro. Stap 1: €15,00 − €8,00 = €7,00. Stap 2: €7,00 − €0,65 = €6,35. Stap 3: je houdt €6,35 over.",
        "distractorExplanations": {
          "0": "Correct! €15,00 − €8,65 = €6,35.",
          "1": "Veelgemaakte fout: de centen verkeerd aftrekken. €7,00 − €0,65 = €6,35 (niet €6,45). Controleer: 100 − 65 = 35 cent.",
          "2": "Veelgemaakte fout: de centen vergeten af te trekken. €15 − €8 = €7, maar je moet ook nog €0,65 aftrekken: €7,00 − €0,65 = €6,35.",
          "3": "Veelgemaakte fout: de euro's verkeerd aftrekken. €15,00 − €8,65 = €6,35 (niet €5,35). Controleer: €8,65 + €6,35 = €15,00 ✓."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-005",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een broodje kost €3,45. Je koopt er 2. Je betaalt met €10,00. Hoeveel wisselgeld krijg je?",
      "options": ["€3,10", "€3,00", "€6,55", "€2,10"],
      "correctAnswer": 0,
      "conceptId": "money_multi_step",
      "variantIndex": 5,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerdere stappen",
            "content": "Eerst: 2 × €3,45 = €6,90. Dan: €10,00 − €6,90 = €3,10. Je krijgt €3,10 wisselgeld."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken eerst de totale kosten, dan het wisselgeld. Stap 1: 2 × €3,45 = €6,90 (2 × €3 = €6, 2 × €0,45 = €0,90). Stap 2: wisselgeld = €10,00 − €6,90 = €3,10.",
        "distractorExplanations": {
          "0": "Correct! 2 × €3,45 = €6,90, dan €10,00 − €6,90 = €3,10.",
          "1": "Veelgemaakte fout: de centen vergeten bij het wisselgeld. €10,00 − €6,90 = €3,10 (niet €3,00). Let op: 100 − 90 = 10 cent.",
          "2": "Veelgemaakte fout: de totale kosten verwarren met het wisselgeld. €6,90 is het totaal dat je betaalt, niet het wisselgeld. Wisselgeld = €10,00 − €6,90 = €3,10.",
          "3": "Veelgemaakte fout: maar 1 broodje rekenen. €10,00 − €3,45 = €6,55 (voor 1 broodje). Maar je koopt er 2: 2 × €3,45 = €6,90, dan €10,00 − €6,90 = €3,10."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-006",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een liter melk kost €1,25. Hoeveel kosten 4 liter?",
      "options": ["€5,00", "€5,25", "€4,00", "€4,25"],
      "correctAnswer": 0,
      "conceptId": "money_multiplication_quarters",
      "variantIndex": 6,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met €1,25",
            "content": "4 × €1,25 = €5,00. Reken: 4 × €1,00 = €4,00, dan 4 × €0,25 = €1,00. Totaal: €5,00."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de vermenigvuldiging in euro's en centen apart. Stap 1: 4 × €1,00 = €4,00. Stap 2: 4 × €0,25 = €1,00. Stap 3: tel op: €4,00 + €1,00 = €5,00.",
        "distractorExplanations": {
          "0": "Correct! 4 × €1,25 = €5,00.",
          "1": "Veelgemaakte fout: de centen verkeerd vermenigvuldigen. 4 × 25 cent = 100 cent = €1,00 (niet €1,25). Totaal: €4,00 + €1,00 = €5,00.",
          "2": "Veelgemaakte fout: de centen vergeten. 4 × €1 = €4, maar je moet ook 4 × €0,25 = €1,00 bijtellen. Totaal: €5,00.",
          "3": "Veelgemaakte fout: te weinig liters rekenen. €4,25 ≈ 3 × €1,25 + iets. Je moet 4 liter rekenen: 4 × €1,25 = €5,00."
        }
      }
    },
    {
      "id": "TGL-GELD-KOMMA-007",
      "familyId": "TGL-GELD-KOMMA",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "ordering",
      "question": "Zet deze bedragen op volgorde van klein naar groot.",
      "options": ["€2,50", "€5,00", "€1,75", "€3,20"],
      "correctAnswer": 0,
      "data": {
        "ordering": {
          "items": ["€2,50", "€5,00", "€1,75", "€3,20"],
          "correctOrder": [2, 0, 3, 1]
        }
      },
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 6,
            "highlight": [1.75, 2.5, 3.2, 5],
            "label": "Bedragen op een getallenlijn"
          }
        }
      ],
      "conceptId": "money_ordering",
      "variantIndex": 7,
      "feedback": {
        "explanationText": "Strategie: vergelijk eerst de euro's, dan de centen. Stap 1: €1,75 heeft de minste euro's (1). Stap 2: €2,50 en €3,20 hebben 2 en 3 euro's. Stap 3: €5,00 heeft de meeste euro's (5). Volgorde: €1,75 < €2,50 < €3,20 < €5,00."
      }
    }
  ]
}